import React from 'react';
import { getTrackBackground, Range } from 'react-range';

import type { FacetHandlerProps } from '../../../types';

import { getMinMax } from './utils';

import './styles.scss';

export interface RangeFacet {
  step?: number;
  min?: number;
  max?: number;
}

interface NumberRangeState {
  values: number[];
}

export default class NumberRange extends React.Component<
  FacetHandlerProps<RangeFacet>,
  NumberRangeState
> {
  public state: NumberRangeState = { values: [0, 1] };

  public componentDidUpdate(
    prevProps: FacetHandlerProps<RangeFacet>,
    prevState: NumberRangeState
  ): void {
    const prev = prevProps.facetResult ?? {};
    const curr = this.props.facetResult ?? {};

    const values = getMinMax(
      { min: prev.min, max: prev.max, values: prevState.values },
      { min: curr.min, max: curr.max, values: this.state.values }
    );
    if (values) {
      this.setState({ values });
    }
  }

  public handle = {
    onChange: (values: number[]) => {
      this.setState({ values });
    },
    onFinalChanges: (values: number[]): void => {
      const { facet, facetResult: result } = this.props;
      const [min, max] = values;
      switch (true) {
        case result?.min !== min && result?.max === max:
          this.props.onChange(facet.index, `[${min} TO *]`);
          break;
        case result?.min === min && result?.max !== max:
          this.props.onChange(facet.index, `[* TO ${max}]`);
          break;
        case result?.min !== min && result?.max !== max:
          this.props.onChange(facet.index, `[${min} TO ${max}]`);
          break;
        default:
          this.props.onChange(facet.index, null);
          break;
      }
    }
  };

  public render(): JSX.Element {
    const { min = 0, max = 1, step = 1 } = this.props.facetResult ?? {};

    return (
      <div className="form-group range-input">
        <label>{this.props.facet.label}</label>
        <div className="range-control">
          <Range
            step={step}
            min={min}
            max={max}
            values={this.state.values}
            onFinalChange={this.handle.onFinalChanges}
            onChange={this.handle.onChange}
            renderTrack={({ props, children }) => (
              <div
                {...props}
                className="range-track"
                style={{
                  ...props.style,
                  background: getTrackBackground({
                    min,
                    max,
                    values: this.state.values,
                    colors: ['#ccc', '#337ab7', '#ccc']
                  })
                }}
              >
                {children}
              </div>
            )}
            renderThumb={({ props, value }) => {
              return (
                <div {...props} className="range-thumb" style={props.style}>
                  <div className="badge">{value}</div>
                </div>
              );
            }}
          />
        </div>
      </div>
    );
  }
}
